var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 4H22C22.552 4 23 4.448 23 5V19C23 19.553 22.552 20 22 20H2C1.448 20 1 19.553 1 19V5C1 4.448 1.448 4 2 4ZM20.964 5L12.7085 14.204C12.313 14.5995 11.6715 14.5995 11.276 14.204L3.0205 5H20.964ZM22 18.668L15.896 12.125L22 5.3505V18.668ZM3.0365 19L8.7475 12.8555L10.5975 14.909C11.368 15.679 12.6165 15.679 13.3865 14.909L15.2375 12.8555L20.948 19H3.0365ZM8.0895 12.125L2 5.366V18.6525L8.0895 12.125Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.53dcdf13.svg";
export { ForwardRef as ReactComponent };